import React, { useState } from 'react';
import img1 from '../Components/Images/esl/Nebular_collection.jpg'
import img2 from '../Components/Images/esl/polaris.webp'
import img3 from '../Components/Images/esl/lumina_collection.jpg'

const ProductShowcase = () => {
  const [activeTab, setActiveTab] = useState('nebular');

  const productData = {
    nebular: {
      title: 'NEBULAR',
      subtitle: 'Redefining the future of ESL solutions with Hanshow\'s newest technology and innovation, Hanshow Nebular digital price tag is an upgrade in every way, with proprietary SIP ultra-low power design, extended battery life, and sleek unibody design.',
      buttonText: 'DISCOVER NEBULAR',
      image: img1,
      features: ['Ultra-low power design', 'Extended battery life', 'Sleek unibody design', 'Proprietary SIP technology'],
      data1: 'Normal - 3 Colors',
      data2: 'Pro - 4 Colors'
    },
    polaris: {
      title: 'POLARIS PRO',
      subtitle: 'Advanced ESL solution featuring cutting-edge display technology and enhanced connectivity. Polaris Pro offers superior performance with crystal-clear displays, robust wireless communication, and enterprise-grade reliability for demanding retail environments.',
      buttonText: 'DISCOVER POLARIS PRO',
      image: img2,
      features: ['Crystal-clear displays', 'Enhanced connectivity', 'Enterprise-grade reliability', 'Advanced wireless communication'],
      data1:'Multicolor',
      data2:'7 Flashing LEDs ',
    
    },
    lumina: {
      title: 'LUMINA AQUA',
      subtitle: 'Next-generation ESL platform with innovative aqua-inspired design and smart features. Lumina Aqua combines elegant aesthetics with powerful functionality, delivering exceptional visibility and seamless integration for modern retail spaces.',
      buttonText: 'DISCOVER LUMINA AQUA',
      image: img3,
      features: ['Aqua-inspired design', 'Smart features', 'Exceptional visibility', 'Seamless integration'],
      data1: 'Likely 3 color',
      data2: 'flash support'
    }
  };

  const currentProduct = productData[activeTab];

  return (
    <div className="container-fluid bg-light min-vh-100 py-5">
      <div className="container">
        {/* Tab Navigation */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-8">
            <nav className="nav nav-pills nav-justified bg-white rounded-pill p-2 shadow-sm">
              {Object.entries(productData).map(([key, product]) => (
                <button
                  key={key}
                  className={`nav-link px-4 py-3 fw-bold text-uppercase position-relative ${
                    activeTab === key 
                      ? 'text-primary border-primary testclass1' 
                      : 'text-success border-transparent testclass'
                  }`}
                  onClick={() => setActiveTab(key)}
                  style={{
                    transition: 'all 0.3s ease',
                    border: 'none',
                    background: 'none',
                    fontSize: '0.9rem',
                    letterSpacing: '0.5px',
                    borderBottom: activeTab === key ? '3px solid' : '3px solid transparent',
                    marginBottom: '-1px'
                  }}
                >
                  {product.title}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Content Area */}
        <div className="row align-items-center min-vh-50">
          {/* Text Content */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="pe-lg-4">
              <h1 
                className="display-3 fw-bold text-primary mb-4"
                style={{
                  fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                  letterSpacing: '2px'
                }}
              >
                {currentProduct.title}
              </h1>
              
              <div className="mb-4">
                <div 
                  className="bg-primary"
                  style={{
                    height: '4px',
                    width: '80px',
                    borderRadius: '2px'
                  }}
                ></div>
              </div>

              <p 
                className="fs-5 text-muted mb-4 lh-base"
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.8'
                }}
              >
                {currentProduct.subtitle}
              </p>

              {/* Features */}
              <div className="mb-4">
                <div className="row g-2">
                  {currentProduct.features.map((feature, index) => (
                    <div key={index} className="col-sm-6">
                      <div className="d-flex align-items-center">
                        <div 
                          className="bg-primary rounded-circle me-2"
                          style={{ width: '8px', height: '8px' }}
                        ></div>
                        <small className="text-muted">{feature}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <button 
                className="btn btn-primary btn-lg px-5 py-3 rounded-pill fw-bold text-uppercase shadow-lg"
                style={{
                  letterSpacing: '1px',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease'
                }}

                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(13, 110, 253, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(13, 110, 253, 0.2)';
                }}
                onClick={(e)=>{window.open('https://www.hanshow.com/en','_blank');}}
              >
                {currentProduct.buttonText} →
              </button>
            </div>
          </div>

          {/* Image Content */}
          <div className="col-lg-6">
            <div className="position-relative">
              <div 
                className="bg-white rounded-4 shadow-lg p-4"
                style={{
                  transform: 'perspective(1000px) rotateY(-5deg) rotateX(2deg)',
                  transition: 'all 0.6s ease'
                }}
              >
                <img
                  src={currentProduct.image}
                  alt={currentProduct.title}
                  className="img-fluid rounded-3"
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'contain',
                    transition: 'all 0.6s ease'
                  }}
                />
                
                {/* Floating Price Tag */}
                {/* <div 
                  className="position-absolute bg-white shadow-lg rounded-3 p-3"
                  style={{
                    top: '20px',
                    right: '20px',
                    transform: 'rotate(5deg)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className="text-danger fw-bold fs-4">$65</div>
                  <div className="text-muted small">Digital Price Tag</div>
                </div> */}

                {/* Product Cards Scattered */}
                <div 
                  className="position-absolute bg-white shadow rounded-2 p-2"
                  style={{
                    bottom: '20px',
                    left: '20px',
                    transform: 'rotate(-3deg)',
                    width: '120px'
                  }}
                >
                  <div className="text-center">
                    <div className="bg-danger text-white rounded px-2 py-1 small mb-1">
                      {currentProduct.data1}
                    </div>
                    <div className="text-muted small">{currentProduct.data2}</div>
                  </div>
                </div>
              </div>

              {/* Background Decorative Elements */}
              <div 
                className="position-absolute bg-primary rounded-circle opacity-10"
                style={{
                  width: '200px',
                  height: '200px',
                  top: '-50px',
                  right: '-50px',
                  zIndex: '-1'
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .transition-all {
          transition: all 0.3s ease;
        }
          .testclass{
          
          color:black !important;
        }
        .testclass1{
        color:blue !important
        }
        .hover\\:bg-light:hover {
          background-color: #f8f9fa !important;
        }
        .min-vh-50 {
          min-height: 50vh;
        }
        @media (max-width: 768px) {
          .display-3 {
            font-size: 2.5rem !important;
          }
        }
      `}</style>

      
    </div>

    
  );
};

export default ProductShowcase;